import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../hooks/useAuthorizedRequest';
import { generateAxiosInstanceCommonFileUpload } from '../hooks/useAuthorizedRequestForFileUpload';
import { useNavigate } from 'react-router-dom';
import Pagination from '../components/Pagination';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../components/Navigation';
import { Loader } from '../components/ModalsCommonFunctions';
import { CModal } from '@coreui/react';

const InstituteMaster = () => {
    const authorizedAxios = generateAxiosInstance()
    const authorizedAxiosCommonFileUpload = generateAxiosInstanceCommonFileUpload()
    const initialFormState = {
        instituteBoardMappingId: [],
        instituteStreamormediumMappingId: [],
        instituteName: '',
        address: '',
        state: '',
        district: '',
        city: '',
        pincode: '',
        inchargeName: '',
        contactNumber: '',
        contactNumber2: '',
        allottedSections: '',
        isActive: true,
        email: '',
        website: '',
        logoName: '',
        logoPath: ''
    }

    const [formData, setFormData] = useState([])
    const [instituteData, setInstituteData] = useState(initialFormState)

    const [instituteList, setInstituteList] = useState([])
    const [editId, setEditId] = useState(null)
    const [boardEdit, setBoardEdit] = useState({
        instituteBoardMappingId: []
    })
    const [mediumEdit, setMediumEdit] = useState({
        instituteStreamormediumMappingId: []
    })
    const [inputpdf, setInputPdf] = useState({ value: '' })
    const [StateList, setStateList] = useState([])
    const [CityList, setCityList] = useState([])
    const [DistList, setDistList] = useState([])
    const [showDetails, setShowDetails] = useState("");
    const [visible, setVisible] = useState(false);

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);
    const [addNewInstitute, setAddNewInstitute] = useState(false);

    const [instituteNameSort, setInstituteNameSort] = useState(null);
    const [addressSort, setAddressSort] = useState(null);
    const [principleNameSort, setPrincipleNameSort] = useState(null);
    const [emailSort, setEmailSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["instituteId", "instituteName", "address", "inchargeName", "email", "website"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getInstituteList();
        }
    }, [searchValue]);


    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            setCurrPage(1);
            setInstituteList(await searchArray("A", '/get-institute-master', searchKeys, searchValue.trim()))
        }
    }

    useEffect(() => {
        const apiUrl = `/get-data-for-syllabus-structure-master`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setFormData(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });

        getInstituteList();
    }, []);

    const getInstituteList = () => {
        const apiUrlForInstitute = `/get-institute-master`;
        authorizedAxios && authorizedAxios.get(apiUrlForInstitute)
            .then(response => {
                setInstituteList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const getAddNewInstitute = () => {
        const apiUrlForInstitute = `/get-institute-master`;
        authorizedAxios && authorizedAxios.get(apiUrlForInstitute)
            .then(response => {
                setInstituteList(response.data.result)
                setAddNewInstitute(!addNewInstitute);
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const getStateList = () => {
        const apiUrlForInstitute = `/all-states`;
        authorizedAxios && authorizedAxios.get(apiUrlForInstitute)
            .then(response => {
                setStateList(response.data.result.map((board) => {
                    return {
                        value: board.id,
                        label: board.stateName
                    }
                }))
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const BoardList = formData?.boardData?.map((board) => {
        return {
            value: board.id,
            label: board.boardName
        }
    }) || [];

    useEffect(() => {
        getStateList()
    }, [])

    const StreamOrMediumList = formData?.streamOrMediumData?.map((stream) => {
        return {
            value: stream.id,
            label: stream.streamName
        }
    }) || [];

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;

        setInstituteData((prevData) => {
            if (type === 'checkbox') {
                return {
                    ...prevData,
                    [name]: checked,
                };
            } else if (name === 'contactNumber' || name === 'contactNumber2') {
                // Filter out non-numeric characters and limit to 10 digits
                const filteredValue = value.replace(/[^0-9]/g, '').slice(0, 10);
                return {
                    ...prevData,
                    [name]: filteredValue,
                };
            } else if (name === 'pincode') {
                const filteredValue = value.replace(/[^0-9]/g, '').slice(0, 6);
                return {
                    ...prevData,
                    [name]: filteredValue
                }
            } else {
                return {
                    ...prevData,
                    [name]: value
                }
            }
        });
    };

    const handleChangeBoard = (selectedOptions) => {
        const selectedIds = selectedOptions.map((option) => option.value.toString());
        setInstituteData((prevData) => {
            return {
                ...prevData,
                instituteBoardMappingId: selectedIds,
            }
        })
    }

    const handleChangeState = (selectedOptions) => {
        setInstituteData((prevData) => {
            return {
                ...prevData,
                state: selectedOptions?.label,
            }
        })

        const apiUrlForInstitute = `/state-wise-district-city?id=${selectedOptions?.value}`;
        authorizedAxios && authorizedAxios.get(apiUrlForInstitute)
            .then(response => {
                setCityList(response.data.cities.map((board) => {
                    return {
                        value: board.id,
                        label: board.cityName
                    }
                }))
                setDistList(response.data.districts.map((board) => {
                    return {
                        value: board.id,
                        label: board.districtName
                    }
                }))
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire({
                    text: errorMsg
                })
            });
    }

    const handleChangeDist = (selectedOptions) => {
        setInstituteData((prevData) => {
            return {
                ...prevData,
                district: selectedOptions.label,
            }
        })
    }

    const handleChangeCity = (selectedOptions) => {
        setInstituteData((prevData) => {
            return {
                ...prevData,
                city: selectedOptions.label,
            }
        })

    }

    const handleChangeStreamOrMedium = (selectedOptions) => {
        const selectedIds = selectedOptions.map((option) => option.value.toString());
        setInstituteData((prevData) => {
            return {
                ...prevData,
                instituteStreamormediumMappingId: selectedIds,
            }
        })
    }

    const handleUploadLogo = async (e) => {
        setLoading(true);
        const file = e.target.files[0];
        setInputPdf(e.target)
        const body = new FormData();
        body.append("file", file);
        const apiUrl = "uploadimage";
        authorizedAxiosCommonFileUpload && authorizedAxiosCommonFileUpload.post(apiUrl, body)
            .then((res) => {
                setInstituteData((prevData) => {
                    if (e.target.name === 'logoName' && file) {
                        return {
                            ...prevData,
                            logoPath: res.data.url,
                            logoName: file.name,
                        }
                    }
                })
            })
            .catch((err) => {
                const errMsg = err.response.data.error || "Something went wrong!"
                Swal.fire({
                    text: errMsg
                })
            })
            .finally(() => {
                setLoading(false); // End loading
            });
    }

    const handleUpdateInstitute = (institute) => {
        setInstituteData({
            instituteBoardMappingId: institute.instituteBoardMappingDetails && institute.instituteBoardMappingDetails.map((option) => option.boardMasterId.toString()),
            instituteStreamormediumMappingId: institute.instituteStreamormediumMappingDetails && institute.instituteStreamormediumMappingDetails.map((option) => option.streamOrMediumMasterId.toString()),
            instituteName: institute.instituteName,
            address: institute.address,
            state: institute.state,
            district: institute.district,
            city: institute.city,
            pincode: institute.pincode,
            inchargeName: institute.inchargeName,
            contactNumber: institute.contactNumber,
            contactNumber2: institute.contactNumber2,
            email: institute.email,
            website: institute.website,
            logoName: institute.logoName,
            logoPath: institute.logoPath,
            allottedSections: institute.allottedSections,
        });
        setEditId(institute.id)
    }

    function arraysHaveCommonValues(array1, array2) {
        let commonValuesFound = false;
        for (const value of array1) {
            if (array2.includes(value)) {
                commonValuesFound = true;
                break;
            }
        }
        return commonValuesFound;
    }

    const handleChangeEditBoard = (selectedOptions) => {
        const selectedIds = selectedOptions.map((option) => option.value.toString());

        !arraysHaveCommonValues(selectedIds, instituteData.instituteBoardMappingId) && setBoardEdit((prevData) => {
            return {
                ...prevData,
                instituteBoardMappingId: selectedIds,
            }
        })
    }

    const handleChangeEditMedium = (selectedOptions) => {
        const selectedIds = selectedOptions.map((option) => option.value.toString());

        !arraysHaveCommonValues(selectedIds, instituteData.instituteStreamormediumMappingId) && setMediumEdit((prevData) => {
            return {
                ...prevData,
                instituteStreamormediumMappingId: selectedIds,
            }
        })
    }

    const customStylesBoard = {
        option: (provided, state) => ({
            ...provided,
            background: instituteData.instituteBoardMappingId.includes(state.value.toString()) ? 'lightpink' : 'white',
        }),
    }

    const customStylesMedium = {
        option: (provided, state) => ({
            ...provided,
            background: instituteData.instituteStreamormediumMappingId.includes(state.value.toString()) ? 'lightpink' : 'white',
        }),
    }

    //error
    const initialErrorState = {

    }

    const [error, setError] = useState(initialErrorState)

    const validateForm = () => {
        const mandatoryFields = Object.keys(instituteData).filter(field => !['address', 'state', 'district', 'city', 'pincode', 'contactNumber2', 'website', 'logoName', 'logoPath'].includes(field));

        const contactNumberValid = instituteData.contactNumber.length == 10;
        const contactNumber2Valid = !instituteData.contactNumber2 || instituteData.contactNumber2.length == 10;

        const contactNumberNotSame = instituteData.contactNumber !== instituteData.contactNumber2;

        return Object.values(error).every((error) => error === '') &&
            mandatoryFields.every((field) => typeof instituteData[field] === "string" ? instituteData[field] !== '' : instituteData[field]?.length !== 0) &&
            contactNumberValid && contactNumber2Valid && contactNumberNotSame;
    };

    const validateFalse = () => {
        for (const [key, value] of Object.entries(instituteData)) {
            if (key !== 'address' && key !== 'state' && key !== 'district' && key !== 'city' && key !== 'pincode' && key !== 'contactNumber2' && key !== 'website' && key !== 'logoName' && key !== 'logoPath') {
                if (value == '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        emailRegex.test(instituteData.email) ?
            setError((prevData) => {
                return {
                    ...prevData,
                    email: '',
                }
            })
            : setError((prevData) => {
                return {
                    ...prevData,
                    email: 'Enter valid Email ID',
                }
            })

        if (instituteData.contactNumber.length > 0 && instituteData.contactNumber.length < 10) {
            setError((prevData) => ({
                ...prevData,
                contactNumber: 'Contact number must be at least 10 characters long.',
            }));
        }

        if (instituteData.contactNumber2 && instituteData.contactNumber2.length > 0 && instituteData.contactNumber2.length < 10) {
            setError((prevData) => ({
                ...prevData,
                contactNumber2: 'Contact number 2 must be at least 10 characters long.',
            }));
        }

        if (instituteData.contactNumber2 && instituteData.contactNumber && instituteData.contactNumber.length > 0 && instituteData.contactNumber2.length > 0 && instituteData.contactNumber === instituteData.contactNumber2) {
            setError((prevData) => ({
                ...prevData,
                contactNumber: "Contact number 1 & contact number 2 will not be same.",
                contactNumber2: "Contact number 1 & contact number 2 will not be same.",
            }));
        }
    }

    const checking = () => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(instituteData.email)
    }

    useEffect(() => {
        if (!Object.values(error).every((error) => error === '')) {
            for (const [key, value] of Object.entries(instituteData)) {
                if (key !== 'address' && key !== 'state' && key !== 'district' && key !== 'city' && key !== 'pincode' && key !== 'contactNumber2' && key !== 'website' && key !== 'logoName' && key !== 'logoPath') {
                    if (value == '' || value.length == 0) {
                        setError((prevData) => {
                            return {
                                ...prevData,
                                [key]: 'This field is required.',
                            }
                        })
                    } else {
                        setError((prevData) => {
                            return {
                                ...prevData,
                                [key]: '',
                            }
                        })
                    }
                }
            }

            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            emailRegex.test(instituteData.email) ?
                setError((prevData) => {
                    return {
                        ...prevData,
                        email: '',
                    }
                })
                : setError((prevData) => {
                    return {
                        ...prevData,
                        email: 'Enter valid Email ID',
                    }
                })

            if (instituteData.contactNumber && instituteData.contactNumber.length > 0 && instituteData.contactNumber.length < 10) {
                setError((prevData) => ({
                    ...prevData,
                    contactNumber: 'Contact number must be at least 10 characters long.',
                }));
            } else if (instituteData.contactNumber == '' || instituteData.contactNumber == 0) {
                setError((prevData) => ({
                    ...prevData,
                    contactNumber: 'This field is required.',
                }));
            } else {
                setError((prevData) => ({
                    ...prevData,
                    contactNumber: '',
                }));
            }

            if (instituteData.contactNumber2 && instituteData.contactNumber2.length > 0 && instituteData.contactNumber2.length < 10) {
                setError((prevData) => ({
                    ...prevData,
                    contactNumber2: 'Contact number 2 must be at least 10 characters long.',
                }));
            } else {
                setError((prevData) => {
                    const { contactNumber2, ...rest } = prevData;
                    return rest;
                });
            }

        }
    }, [instituteData])

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(instituteList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId, addNewInstitute])

    useEffect(() => {
        setTotalPages(Math.ceil(instituteList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > instituteList.length) {
            endIndex = instituteList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(instituteList.slice(startIndex, endIndex));
    }, [instituteList, currPage, itemsPerPage]);

    const addInstitute = () => {
        const apiUrl = `/add-institute-master`;
        if (validateForm() && checking()) {
            setLoading(true);
            authorizedAxios && authorizedAxios.post(apiUrl, instituteData)
                .then(response => {
                    getAddNewInstitute();
                    setSaveId(response.data.createdInstitute.id);
                    setInstituteData(initialFormState);
                    setError(initialErrorState);
                    setInstituteNameSort(null);
                    setAddressSort(null);
                    setPrincipleNameSort(null);
                    setEmailSort(null);

                    Swal.fire(
                        { text: response.data.message }
                    );
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire(
                        { text: errorMsg }
                    );
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        } else {
            validateFalse();
        }
    }

    const deleteInstitute = (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            setLoading(true);
            const apiUrl = `/delete-institute-master?id=${id}`;
            authorizedAxios && authorizedAxios.delete(apiUrl)
                .then(response => {
                    const page = deleteItem(currPage, itemsPerPage, instituteList.length);
                    getInstituteList();
                    setCurrPage(page);

                    Swal.fire(
                        { text: response.data.message }
                    );
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire(
                        { text: errorMsg }
                    );
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        }
    }

    const updateInstitute = () => {
        if (validateForm()) {
            setLoading(true);
            const apiUrl = `/edit-institute-master?id=${editId}`;
            const updatedInstituteData = {
                ...instituteData,
                instituteBoardMappingId: boardEdit.instituteBoardMappingId,
                instituteStreamormediumMappingId: mediumEdit.instituteStreamormediumMappingId
            };
            authorizedAxios && authorizedAxios.put(apiUrl, updatedInstituteData)
                .then(response => {
                    getInstituteList();
                    setEditId(null);
                    setInstituteData(initialFormState)
                    setBoardEdit({ instituteBoardMappingId: [] });
                    setMediumEdit({ instituteStreamormediumMappingId: [] });
                    Swal.fire(
                        { text: response.data.message }
                    );
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire(
                        { text: errorMsg }
                    );
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        } else {
            validateFalse();
        }
    }

    const handleReset = () => {
        getInstituteList([]);
        setEditId('');
        inputpdf.value = '';
        setInstituteData(initialFormState);
        setBoardEdit({ instituteBoardMappingId: [] });
        setMediumEdit({ instituteStreamormediumMappingId: [] });
        setInstituteNameSort(null);
        setAddressSort(null);
        setPrincipleNameSort(null);
        setEmailSort(null);
    }

    useEffect(() => {
        if (instituteNameSort == true || instituteNameSort == false) {
            setAddressSort(null);
            setPrincipleNameSort(null);
            setEmailSort(null);
        }
    }, [instituteNameSort])

    useEffect(() => {
        if (addressSort == true || addressSort == false) {
            setInstituteNameSort(null);
            setPrincipleNameSort(null);
            setEmailSort(null);
        }
    }, [addressSort])

    useEffect(() => {
        if (principleNameSort == true || principleNameSort == false) {
            setInstituteNameSort(null);
            setAddressSort(null);
            setEmailSort(null);
        }
    }, [principleNameSort])

    useEffect(() => {
        if (emailSort == true || emailSort == false) {
            setInstituteNameSort(null);
            setAddressSort(null);
            setPrincipleNameSort(null);
        }
    }, [emailSort])


    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>

                            <li className="breadcrumb-item active"><span>Institute Master</span></li>
                        </ol>
                    </nav>
                </div>
                <div id='scroll-up'></div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa fa-building-columns"></i>Institute Master</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                {editId ?
                                                    <>
                                                        <div className="col-md-6">
                                                            <label for="instituteBoardMappingId" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Board : {instituteData.instituteBoardMappingId.length} selected</label>
                                                            <Select
                                                                value={BoardList.filter(option =>
                                                                    boardEdit.instituteBoardMappingId && boardEdit.instituteBoardMappingId.includes(option.value.toString())
                                                                )}
                                                                isMulti
                                                                name="instituteBoardMappingId"
                                                                options={BoardList}
                                                                className="basic-multi-select"
                                                                classNamePrefix="Select Board"
                                                                onChange={handleChangeEditBoard}
                                                                styles={customStylesBoard}
                                                            />
                                                        </div>

                                                        <div className="col-md-6">
                                                            <label for="instituteStreamormediumMappingId" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Medium : {instituteData.instituteStreamormediumMappingId.length} selected</label>
                                                            <Select
                                                                value={StreamOrMediumList.filter(option =>
                                                                    mediumEdit.instituteStreamormediumMappingId && mediumEdit.instituteStreamormediumMappingId.includes(option.value.toString())
                                                                )}
                                                                isMulti
                                                                name="instituteStreamormediumMappingId"
                                                                options={StreamOrMediumList}
                                                                className="basic-multi-select"
                                                                classNamePrefix="Select Medium"
                                                                onChange={handleChangeEditMedium}
                                                                styles={customStylesMedium}
                                                            />
                                                        </div>
                                                    </>
                                                    :
                                                    <>
                                                        <div className="col-md-6">
                                                            <label for="instituteBoardMappingId" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Board : </label>
                                                            <Select
                                                                value={BoardList.filter(option =>
                                                                    instituteData?.instituteBoardMappingId && instituteData?.instituteBoardMappingId.includes(option.value.toString())
                                                                )}
                                                                isMulti
                                                                name="instituteBoardMappingId"
                                                                options={BoardList}
                                                                className="basic-multi-select"
                                                                classNamePrefix="Select Board"
                                                                onChange={handleChangeBoard}
                                                            />
                                                            {error.instituteBoardMappingId && <p style={{ color: 'red' }}>{error.instituteBoardMappingId}</p>}
                                                        </div>
                                                        <div className="col-md-6">
                                                            <label for="instituteStreamormediumMappingId" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Medium :</label>
                                                            <Select
                                                                value={StreamOrMediumList.filter(option =>
                                                                    instituteData.instituteStreamormediumMappingId && instituteData.instituteStreamormediumMappingId.includes(option.value.toString())
                                                                )}
                                                                isMulti
                                                                name="instituteStreamormediumMappingId"
                                                                options={StreamOrMediumList}
                                                                className="basic-multi-select"
                                                                classNamePrefix="Select Medium"
                                                                onChange={handleChangeStreamOrMedium}
                                                            />
                                                            {error.instituteStreamormediumMappingId && <p style={{ color: 'red' }}>{error.instituteStreamormediumMappingId}</p>}
                                                        </div>
                                                    </>
                                                }

                                                <div className="col-md-6">
                                                    <label for="instituteName" className="col-form-label"><span style={{ color: "red" }}>*</span>Enter Institute Name :</label>
                                                    <input type="text" className="form-control" name="instituteName" value={instituteData.instituteName} onChange={handleInputChange} />
                                                    {error.instituteName && <p style={{ color: 'red' }}>{error.instituteName}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inchargeName" className="col-form-label"><span style={{ color: "red" }}>*</span>Principle Name :</label>
                                                    <input type="text" className="form-control" name="inchargeName" value={instituteData.inchargeName} onChange={handleInputChange} />
                                                    {error.inchargeName && <p style={{ color: 'red' }}>{error.inchargeName}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="address" className="col-form-label">Address :</label>
                                                    <input type="text" className="form-control" name="address" value={instituteData.address} onChange={handleInputChange} />
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="state" className="col-form-label">State :</label>
                                                    <Select
                                                        value={instituteData.state == '' ? null : StateList.filter(option =>
                                                            instituteData.state && instituteData.state == option.label && (option.value)
                                                        )[0]}
                                                        name="state"
                                                        options={StateList}
                                                        className="basic-multi-select"
                                                        classNamePrefix="Select Board"
                                                        onChange={handleChangeState}
                                                    />
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="district" className="col-form-label">District :</label>
                                                    <Select
                                                        value={instituteData.district == '' ? null : DistList.filter(option =>
                                                            instituteData.district && instituteData.district == option.label && (option.value)
                                                        )[0]}
                                                        name="district"
                                                        options={DistList}
                                                        className="basic-multi-select"
                                                        classNamePrefix="Select Board"
                                                        onChange={handleChangeDist}
                                                    />
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="city" className="col-form-label">City :</label>
                                                    <input type="text" className="form-control" name="city" value={instituteData.city} onChange={handleInputChange} />
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="pincode" className="col-form-label">Pincode :</label>
                                                    <input type="text" onWheel={(e) => e.currentTarget.blur()} min="0" className="form-control custom-input" name="pincode" value={instituteData.pincode} onChange={handleInputChange} />
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="contactNumber" className="col-form-label"><span style={{ color: "red" }}>*</span>Contact Number :</label>
                                                    <input type="text" inputMode="numeric" pattern="^\d{10}$" onWheel={(e) => e.currentTarget.blur()} min="0" className="form-control custom-input" name="contactNumber" value={instituteData.contactNumber} onChange={handleInputChange} />
                                                    {error.contactNumber && <p style={{ color: 'red' }}>{error.contactNumber}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="contactNumber2" className="col-form-label">Contact Number II :</label>
                                                    <input type="text" pattern="^\d{10}$" onWheel={(e) => e.currentTarget.blur()} min="0" className="form-control custom-input" name="contactNumber2" value={instituteData.contactNumber2} onChange={handleInputChange} />
                                                    {error.contactNumber2 && <p style={{ color: 'red' }}>{error.contactNumber2}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="email" className="col-form-label"><span style={{ color: "red" }}>*</span>Email-Id :</label>
                                                    <input type="email" className="form-control" name="email" value={instituteData.email} onChange={handleInputChange} />
                                                    {error.email && <p style={{ color: 'red' }}>{error.email}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="website" className="col-form-label">Website :</label>
                                                    <input type="text" className="form-control" name="website" value={instituteData.website} onChange={handleInputChange} />
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="allottedSections" className="col-form-label"><span style={{ color: "red" }}>*</span>No. of Alloted Sections :</label>
                                                    <input type="number" onWheel={(e) => e.currentTarget.blur()} min="0" className="form-control" name="allottedSections" value={instituteData.allottedSections} onChange={handleInputChange} />
                                                    {error.allottedSections && <p style={{ color: 'red' }}>{error.allottedSections}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="logoName" className="col-form-label">Upload Institute logo :</label>
                                                    <input type="file" className="form-control" name="logoName" onChange={handleUploadLogo} />
                                                </div>
                                                {instituteData.logoName && (
                                                    <div style={{ marginTop: '10px' }}>
                                                        Selected logo: {instituteData.logoName}
                                                    </div>
                                                )}
                                                <div className="col-md-6">
                                                    <label for="isActive" className="col-form-label">Active Status :</label>
                                                    <input type="checkbox" name="isActive" defaultValue={false} checked={instituteData?.isActive} style={{
                                                        marginLeft: '20px', width: '18px',
                                                        height: '16px',
                                                        accentColor: 'green', marginTop: '20px',
                                                    }} onChange={handleInputChange} />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12 mt-3 d-flex justify-content-center button-container">
                                                    {!editId && <button className="btn btn-primary" type="button" onClick={addInstitute}>Save</button>}
                                                    <button className="btn btn-danger delete_icon delete-icon " type="reset" onClick={handleReset}>Reset</button>
                                                    {editId && (<button className="btn btn-success approve_icon" type="button" onClick={updateInstitute} disabled={!editId}>Update</button>)}
                                                </div>

                                                {visible && <CModal
                                                    visible={visible}
                                                    onClose={() => setVisible(false)}
                                                    aria-labelledby="LiveDemoExampleLabel"
                                                    onIni
                                                >
                                                    <div className="book book-modal">
                                                        <h2 className='table-header-like'>Full Details</h2>
                                                        <div className='page'>
                                                            <p>Institute Id: {showDetails.instituteId}</p>
                                                            <p>Institute Name: {showDetails.instituteName}</p>
                                                            <p>Principle Name: {showDetails.inchargeName}</p>
                                                            {showDetails.address && <p>Address: {showDetails.address}</p>}
                                                            {showDetails.state && <p>State: {showDetails.state}</p>}
                                                            {showDetails.district && <p>District: {showDetails.district}</p>}
                                                            {showDetails.city && <p>City: {showDetails.city}</p>}
                                                            {showDetails.pincode && <p>Pincode: {showDetails.pincode}</p>}
                                                            <p>Contact Number: {showDetails.contactNumber}</p>{showDetails.contactNumber2 && <p>, {showDetails.contactNumber2}</p>}
                                                            <p>Email: {showDetails.email}</p>
                                                            {showDetails.website && <p>Website: {showDetails.website}</p>}
                                                            {showDetails.allottedSections && <p>Allocated Sections: {showDetails.allottedSections}</p>}
                                                        </div>
                                                        <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => setVisible(false)}>
                                                            Close
                                                        </button>
                                                    </div>
                                                </CModal>}

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table custom_table_width">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">Institute Id</th>
                                                                        <th scope="col" style={{ width: '340px' }}>
                                                                            Institute Name
                                                                            <SortIcon sortState={instituteNameSort} setSortState={setInstituteNameSort} setData={setInstituteList} setCurrPage={setCurrPage} sortingPath={"instituteName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Principle Name
                                                                            <SortIcon sortState={principleNameSort} setSortState={setPrincipleNameSort} setData={setInstituteList} setCurrPage={setCurrPage} sortingPath={"inchargeName"} />
                                                                        </th>
                                                                        <th scope="col" style={{ width: '200px' }}>
                                                                            Email
                                                                            <SortIcon sortState={emailSort} setSortState={setEmailSort} setData={setInstituteList} setCurrPage={setCurrPage} sortingPath={"email"} />
                                                                        </th>
                                                                        <th scope="col" className='ins_id'>Phone No</th>
                                                                        <th scope="col">Full Details</th>
                                                                        <th scope="col">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData.length > 0 ?
                                                                            displayedData.map((institute, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{institute.instituteId}</td>
                                                                                        <td>{institute.instituteName}</td>
                                                                                        <td>{institute.inchargeName}</td>
                                                                                        <td>{institute.email}</td>
                                                                                        <td className='ins_id'>{institute.contactNumber} <br /> {institute.contactNumber2}</td>
                                                                                        <td>
                                                                                            <button className="btn btn-primary view_icon" type="button" onClick={() => {
                                                                                                setShowDetails(institute);
                                                                                                setVisible(!visible)
                                                                                            }}><i class="fa fa-eye" ></i></button>
                                                                                        </td>
                                                                                        <td>
                                                                                            <button className="btn btn-outline-warning edit_icon" type="button" style={{ marginRight: '5px' }} onClick={() => {
                                                                                                handleUpdateInstitute(institute);
                                                                                                if (institute.state) {
                                                                                                    handleChangeState(StateList.find(i => i?.label === institute?.state));
                                                                                                }
                                                                                                document.getElementById('scroll-up').scrollIntoView({ behavior: 'smooth' });
                                                                                            }
                                                                                            }><i class="fa-light fa-pen-to-square"></i></button>
                                                                                            <button className="btn btn-outline-danger delete_icon" type="button" disabled={editId === institute.id} onClick={() => deleteInstitute(institute.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Institutes Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>

                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={instituteList.length} />

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default InstituteMaster;